export var createMuiFormControlOverrides = function () {
    return {
        defaultProps: {
            fullWidth: true,
            variant: 'outlined',
        },
        styleOverrides: {
            root: {
                maxWidth: 400,
            },
            fullWidth: {
                maxWidth: '100%',
            },
        },
    };
};
